import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, formatDate } from "@/lib/api";
import { PageHeader, StatusBadge, adminBtnPrimary } from "@/components/admin/ui";

export default function AdminVideos() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/videos").then((r) => { setItems(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this video?")) return;
    await api.delete(`/admin/videos/${id}`);
    toast.success("Video deleted");
    load();
  };

  return (
    <>
      <PageHeader title="Videos" subtitle="Add YouTube or Vimeo videos to the library.">
        <Link to="/admin/videos/new" className={adminBtnPrimary} data-testid="new-video-button"><Plus className="h-4 w-4" /> New Video</Link>
      </PageHeader>

      <div className="overflow-hidden border border-ink/10 bg-cream-100">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-ink/10 font-sans text-xs uppercase tracking-wide text-steel-500">
              <th className="px-5 py-3">Title</th>
              <th className="px-5 py-3">Topic</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Updated</th>
              <th className="px-5 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((v) => (
              <tr key={v.id} className="border-b border-cream-200 last:border-0" data-testid={`admin-video-row-${v.id}`}>
                <td className="px-5 py-4">
                  <Link to={`/admin/videos/${v.id}`} className="font-sans text-sm font-medium text-ink hover:text-gold-600">{v.title || "Untitled"}</Link>
                  {v.featured && <span className="ml-2 font-sans text-xs text-gold-600">★ Featured</span>}
                </td>
                <td className="px-5 py-4 font-sans text-sm text-steel-600">{v.topic || "—"}</td>
                <td className="px-5 py-4"><StatusBadge status={v.status} /></td>
                <td className="px-5 py-4 font-sans text-sm text-steel-500">{formatDate(v.updated_at)}</td>
                <td className="px-5 py-4">
                  <div className="flex items-center justify-end gap-2">
                    {v.status === "published" && <a href={`/videos/${v.slug}`} target="_blank" rel="noreferrer" className="text-steel-500 hover:text-gold-600"><ExternalLink className="h-4 w-4" /></a>}
                    <Link to={`/admin/videos/${v.id}`} className="text-steel-500 hover:text-gold-600"><Pencil className="h-4 w-4" /></Link>
                    <button onClick={() => remove(v.id)} className="text-steel-500 hover:text-destructive" data-testid={`delete-video-${v.id}`}><Trash2 className="h-4 w-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && items.length === 0 && <p className="py-16 text-center font-sans text-sm text-steel-400">No videos yet. Add your first video.</p>}
        {loading && <p className="py-16 text-center font-sans text-sm text-steel-400">Loading…</p>}
      </div>
    </>
  );
}
